const getBool = function (_bool) {
    switch (_bool) {
        case 0:
        case "0":
        case "false":
        case false:
            return false;
        case 1:
        case "1":
        case "true":
        case true:
            return true;
        default:
            return false;
    }
};

const setBool = function (_bool) {
    switch (_bool) {
        case 0:
        case "0":
        case "false":
        case false:
            return 0;
        case 1:
        case "1":
        case "true":
        case true:
            return 1;
        default:
            return 0;
    }
};

export { getBool, setBool };
